// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2SBeH","select":"Header_select__26eGI","clinic":"Header_clinic__VkMvK"};